/*
 * Copyright (c) 2019 Hawaii Information Consortium
 * 201 Merchant St #1805, Honolulu, HI 96813
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of Hawaii Information Consortium. ("Confidential Information"). You
 * shall not disclose such Confidential Information and shall use
 * it only in accordance with the terms of the license agreement
 * you entered into with HIC.
 */

import { Pipe, PipeTransform } from '@angular/core';
import Big from 'big.js';
import { CURRENCY_ROUNDING_MODE } from '@app/util/currency';

@Pipe({
  name: 'bigCurrency'
})

export class BigCurrencyPipe implements PipeTransform {

  transform(value: any): string {
    if (null != value) {
      let val: Big = new Big(value).round(2, CURRENCY_ROUNDING_MODE);
      const negative = val.lt(0);
      val = val.abs();
      const val_str = val.toFixed(2).toString().split('.');
      val_str[0] = val_str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `${(negative ? '-' : '')}\$${val_str.join('.')}`;
    } else {
      return null;
    }
  }

}



